export default __webpack_public_path__ + "static/media/mixology-desktop-pattern.47578de9.png";